module.exports = __webpack_public_path__ + "static/media/2.26ec7a93.jpg";